import {
  CompsListingsSearchCriteria,
  GeoSearch,
  MILES_TO_METERS,
  SubjectData,
} from '@aloft/toolkit-shared';

import { InitialCompSearch } from '../types.ts';
import { DEFAULT_RECOMMENDED_COMP_PROPERTY_SUB_TYPE } from './getDefaultRecommendedCompSearch.ts';

const replaceUndefinedWithEmptyString = <T extends Record<string, any>>(obj: T): T => {
  const newObj: Record<string, any> = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] === undefined) {
      newObj[key] = '';
    } else {
      newObj[key] = obj[key];
    }
  });
  return newObj as T;
};

export const loadExistingSearchCriteria = (
  existingSearchCriteria: CompsListingsSearchCriteria,
  subject: SubjectData,
  getDefaultFormValues: () => InitialCompSearch['body']['search'],
): InitialCompSearch['body']['search'] => {
  const subjectCoords = {
    lon: subject.editableData.propertyIdentification.coordinates?.longitude || 0,
    lat: subject.editableData.propertyIdentification.coordinates?.latitude || 0,
  };
  let geoSearch: GeoSearch;
  if (existingSearchCriteria.coordinates && existingSearchCriteria.coordinates.length > 2) {
    geoSearch = {
      t: 'polygon',
      coords: existingSearchCriteria.coordinates.map((coordinate) => [
        coordinate.longitude,
        coordinate.latitude,
      ]),
    };
  } else {
    geoSearch = {
      t: 'radius',
      radiusInMeters: existingSearchCriteria.radius
        ? existingSearchCriteria.radius * MILES_TO_METERS
        : MILES_TO_METERS,
      coord: [subjectCoords.lon, subjectCoords.lat],
    };
  }
  const search = {
    filters: {
      ...existingSearchCriteria.filters,
      status: existingSearchCriteria.filters?.status?.trim() ?? '',
      propertySubType:
        existingSearchCriteria.filters?.propertySubType?.trim() ||
        DEFAULT_RECOMMENDED_COMP_PROPERTY_SUB_TYPE,
      saleDate: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.saleDate || {}),
      salePrice: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.salePrice || {}),
      gla: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.gla || {}),
      lotSize: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.lotSize || {}),
      yearBuilt: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.yearBuilt || {}),
      bedrooms: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.bedrooms || {}),
      fullBaths: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.fullBaths || {}),
      stories: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.stories || {}),
      garageSpaces: replaceUndefinedWithEmptyString(
        existingSearchCriteria.filters?.garageSpaces || {},
      ),
    },
    geoSearch,
    matchCriteria: existingSearchCriteria.matchCriteria || getDefaultFormValues().matchCriteria,
  };

  return search as InitialCompSearch['body']['search'];
};
